import { render, staticRenderFns } from "./MbView.vue?vue&type=template&id=349f75aa&scoped=true&"
import script from "./MbView.vue?vue&type=script&lang=ts&"
export * from "./MbView.vue?vue&type=script&lang=ts&"
import style0 from "./MbView.vue?vue&type=style&index=0&id=349f75aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349f75aa",
  null
  
)

export default component.exports